import { PersonalizeProductComponent } from './../modals/personalize-product/personalize-product.component';
// import { OrderTypeComponent } from '@app/modules/modals/order-type/order-type.component';
import { Router } from "@angular/router";
import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  ChangeDetectorRef,
  ViewChild,
  OnDestroy
} from "@angular/core";
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { combineLatest, Subscription } from "rxjs";
import { OrdersService } from '@app/services/order/orders.service';
import { PdvService } from '@app/services/pdv/pdv.service';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: "app-panier",
  templateUrl: "./panier.component.html",
  styleUrls: ["./panier.component.scss"]
})
export class PanierComponent implements OnInit, OnDestroy {
  bsModalRef: BsModalRef;
  modalRef: BsModalRef;
  config = {
    ignoreBackdropClick: true
  };
  orderTypes: any[] = [];
  chosenOrderType: number;
  orderType: number;
  orderTypLabel: String = "";
  @ViewChild("template")
  template;
  @ViewChild("template2")
  template2;
  @Input()
  updatePanier = true;
  @Input()
  showButton: boolean;
  @Input()
  header = 0;
  @Output()
  update = new EventEmitter<number>();
  @Output()
  setOrderType = new EventEmitter<number>();
  subscriptions: Subscription[] = [];
  subscriptions2: Subscription[] = [];
  order: any = {};
  elementsNbr: number;
  amountMiniDelivery: number;
  amountMiniMandatory: number;
  // header: boolean=false;
  constructor(
    private modalService: BsModalService,
    private changeDetection: ChangeDetectorRef,
    private orderService: OrdersService,
    private pdvService: PdvService,
    private router: Router,
    private toastr: ToastrService
  ) {
    const sub4 = this.orderService.order.subscribe(order => {
      this.order = order;
      this.elementsNbr = order.elementsNbr;
    });
    const sub5 = this.orderService.amountMiniDelivery.subscribe(amountMiniDelivery => {
      this.amountMiniDelivery = amountMiniDelivery;
    });
    const sub6 = this.pdvService.pdv.subscribe((data:any) => {
      this.amountMiniMandatory = data.amountMiniMandatory;
    });
    const subs1 = this.pdvService.orderTypes.subscribe((orderTypes: any[]) => {
      this.orderTypes = orderTypes;
      if (this.chosenOrderType > 0) {
        this.orderTypLabel = this.orderTypes.filter(
          o => o.id === this.chosenOrderType
        )[0].label;
      }
    });
    const subs2 = this.orderService.chosenOrderType.subscribe(
      (chosenOrderType: number) => {
        this.chosenOrderType = chosenOrderType;
        if (this.orderTypes.length > 0 && chosenOrderType > 0) {
          this.orderTypLabel = this.orderTypes.filter(
            o => o.id === this.chosenOrderType
          )[0].label;
        }
      }
    );
    this.subscriptions2
    this.subscriptions2.push(subs1, subs2, sub4, sub5,sub6);
  }

  ngOnInit() { }


  incrQty(i, j) {
    this.orderService.incrQty(i, j);
  }

  decrQty(i, j) {
    this.orderService.decrQty(i, j);
  }

  removeElement(i, j) {
    this.orderService.removeElement(i, j);
  }

  clear() {
    this.orderService.clearOrder();
  }

  updateElement(i) {
    if (this.updatePanier) {
      const _combine = combineLatest(
        this.modalService.onHidden
      ).subscribe(() => this.changeDetection.markForCheck());
      this.subscriptions.push(
        this.modalService.onHidden.subscribe((element: any) => {
          if (element) {
            this.orderService.updateElement(element,i);
          }
          this.unsubscribe();
        })
      );
      this.subscriptions.push(_combine);
      this.bsModalRef = this.modalService.show(PersonalizeProductComponent, {
        class: "modal-content3"
      });
      this.bsModalRef.content.product2 = JSON.parse(
        JSON.stringify(this.order.elements[i])
      );
    }
  }

  checkoutEvent() {
    if (this.chosenOrderType == 1) {
      if (Number(this.order.total) >= Number(this.amountMiniDelivery)) {
        this.router.navigate(["/checkout"]);
      } else {
        if (this.amountMiniMandatory == 0) {
          this.modalRef = this.modalService.show(this.template2, { class: 'modal-sm' });
        } else {
          this.toastr.error('', 'Minimum de livraison: ' + this.amountMiniDelivery + ' €');
        }
      }
    } else {
      this.router.navigate(["/checkout"]);
    }
  }

  changeMode() {
    if (this.elementsNbr > 0) {
      this.modalRef = this.modalService.show(this.template, {
        class: "ordertype-modal"
      });
    } else {
      // this.setOrderTypeEvent();
    }
  }

  // setOrderTypeEvent() {
  //   this.bsModalRef = this.modalService.show(OrderTypeComponent, {
  //     class: "modal-content2"
  //   });
  //   const _combine = combineLatest(
  //     this.modalService.onHidden
  //   ).subscribe(() => this.changeDetection.markForCheck());
  //   this.subscriptions.push(
  //     this.modalService.onHidden.subscribe((data: any) => {
  //       if (data) {
  //         // if (this.chosenOrderType !== data.orderType) {
  //           this.orderService.chosenOrderType.next(data.orderType);
  //           // this.orderService.orderType.next(data.orderType);
  //           this.orderType = data.orderType;
  //         // }
  //       }
  //       this.unsubscribe();
  //     })
  //   );
  //   this.subscriptions.push(_combine);
  // }

  unsubscribe() {
    this.subscriptions.forEach((subscription: Subscription) => {
      subscription.unsubscribe();
    });
    this.subscriptions = [];
  }

  unsubscribe2() {
    this.subscriptions2.forEach((subscription: Subscription) => {
      subscription.unsubscribe();
    });
    this.subscriptions2 = [];
  }

  confirm() {
    this.modalRef.hide();
    this.orderService.clearOrder();
    setTimeout(() => {
      // this.setOrderTypeEvent();
    }, 1000)
  }
  confirm2() {
    this.modalRef.hide();
    this.router.navigate(["/checkout"]);
  }

  decline() {
    this.modalRef.hide();
  }

  ngOnDestroy() {
    this.unsubscribe2();
  }
}
